import React from 'react';
import ErrorUnhandled from '../ErrorUnhandled';
import ErrorUnauthenticated from '../ErrorUnauthenticated';

const Error = ({ error }) => {
  if (error?.response?.status === 401) {
    return <ErrorUnauthenticated title="Your session has expired." view="error_session_expired" />;
  }

  return <ErrorUnhandled />;
};

export default Error;
